//IMPORTS
import React from "react";

import "../../scss/Modal.scss";

export const Modal = ({ setModal, image }) => {
  //

  return (
    <div className='modalBackground'>
      <div
        className='modalContainer'
        onClick={() => {
          setModal(false);
        }}
      >
        <div className='titleCloseBtn'>
          <button
            onClick={() => {
              setModal(false);
            }}
          >
            X
          </button>
        </div>
        <div>
          <div className='imageContainer'>
            <img src={image.imageSmall} alt='' />
          </div>
          <p style={{ textAlign: "center" }}>{image.desc}</p>
        </div>
      </div>
    </div>
  );
};
